import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Get language from localStorage or default to 'en'
const getStoredLanguage = () => {
  const stored = localStorage.getItem("currentLang");
  return stored || "en";
};

const resources = {
  en: {
    translations: {
      welcome: "Welcome to GSMI",
      // Language switcher
      language: "Language",
      english: "English",
      french: "Français",
      // Header translations
      email: "gsmi@um6p.ma",
      website: "www.um6p.ma",
      contactUs: "Contact Us",
    }
  },
  fr: {
    translations: {
      welcome: "Bienvenue à GSMI",
      // Language switcher
      language: "Langue",
      english: "English",
      french: "Français",
      // Header translations
      email: "gsmi@um6p.ma",
      website: "www.um6p.ma",
      contactUs: "Contactez-nous",
    }
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguage(),
    fallbackLng: "en",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      useSuspense: false
    }
  })
  .then(() => {
    console.log("i18n initialized successfully");
  })
  .catch((error) => {
    console.error("i18n initialization failed:", error);
  });

// Function to change language and store in localStorage
export const changeLanguage = (lng) => {
  localStorage.setItem("currentLang", lng);
  i18n.changeLanguage(lng).then(() => {
  }).catch((error) => {
    console.error("Failed to change language:", error);
  });
};

export default i18n;
